module.exports = __webpack_public_path__ + "img/icon-home-popup-file.6d96ddf7.svg";